// 审核--后端存储
export const REVIEW_STATUS_ENUM: Record<string, number> = {
  REVIEWING: 0, // 审核中
  PASS: 1, // 审核通过
  REJECT: 2, // 审核拒绝
};

// 审核映射--前端展示
export const REVIEW_STATUS_MAP: Record<number, string> = {
  0: "待审核",
  1: "通过",
  2: "拒绝",
};

//同理
// 应用类型枚举
export const APP_TYPE_ENUM: Record<string, number> = {
  // 得分类
  SCORE: 0,
  // 测评类
  TEST: 1,
};

// 应用类型映射
export const APP_TYPE_MAP: Record<number, string> = {
  0: "得分类",
  1: "测评类",
};

// 应用评分策略枚举
export const APP_SCORING_STRATEGY_ENUM: Record<string, number> = {
  // 自定义
  CUSTOM: 0,
  // AI
  AI: 1,
};

// 应用评分策略映射
export const APP_SCORING_STRATEGY_MAP: Record<number, string> = {
  0: "自定义",
  1: "AI",
};
